import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, Info, EnvelopeSimple, ShieldCheck, FileText, CreditCard, Book } from '@phosphor-icons/react';

const TopNav = ({ showHome = false }) => {
  const location = useLocation();
  
  const links = [
    ...(showHome ? [{ to: '/welcome', label: 'Home', icon: House }] : []),
    { to: '/about', label: 'About', icon: Info },
    { to: '/contact', label: 'Contact', icon: EnvelopeSimple },
    { to: '/privacy', label: 'Privacy', icon: ShieldCheck },
    { to: '/terms', label: 'Terms', icon: FileText },
    { to: '/refund-policy', label: 'Refund Policy', icon: FileText },
    { to: '/pricing', label: 'Pricing', icon: CreditCard },
  ];

  return (
    <nav className="bg-background/80 backdrop-blur-xl border-b border-border/50 px-4 py-2 sticky top-0 z-50">
      <div className="max-w-4xl mx-auto flex items-center justify-center gap-1 sm:gap-3 flex-wrap">
        {links.map(({ to, label, icon: Icon }) => {
          const isActive = location.pathname === to;
          return (
            <Link
              key={to}
              to={to}
              className={`flex items-center gap-1 px-2 sm:px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                isActive 
                  ? 'bg-[#D4AF37]/20 text-[#D4AF37]' 
                  : 'text-muted-foreground hover:text-foreground hover:bg-card'
              }`}
              data-testid={`nav-${label.toLowerCase().replace(' ', '-')}`}
            >
              <Icon weight={isActive ? 'fill' : 'regular'} className="w-3.5 h-3.5" />
              <span className="hidden sm:inline">{label}</span>
            </Link>
          );
        })}
        {/* Buy the Book - highlighted green */}
        <Link
          to="/buy-book"
          className={`flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-bold transition-all ${
            location.pathname === '/buy-book'
              ? 'bg-emerald-600 text-white'
              : 'bg-emerald-600/20 text-emerald-400 hover:bg-emerald-600/30 hover:text-emerald-300'
          }`}
          data-testid="nav-buy-book"
        >
          <Book weight="fill" className="w-3.5 h-3.5" />
          <span className="hidden sm:inline">Buy the Book</span>
        </Link>
      </div>
    </nav>
  );
};

export default TopNav;
